module.exports = __webpack_public_path__ + "img/graves.79128344.jpg";